<div class="custom-modal">
    <div class="header">
        <h1 mat-dialog-title>
            Detalhe do Manifesto de Embarque {{modalItem.manifestoEmbarqueId}}
        </h1>
        <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
    <div class="header">
        <mat-card-content class="no-padding">
            <form class="filtros-header" [formGroup]="codBarrasDetalheForm">
                <div class="row" style="display: inherit;">
                    <mat-form-field>
                        <mat-label>Código de Barras</mat-label>
                        <input matInput autocomplete="off" formControlName="codigoBarras">
                    </mat-form-field>
                    <button mat-icon-button class="notification-button cursor-pointer-icon"
                        (click)="clearFields()" matTooltip="Limpar Campos">
                        <mat-icon fontSet="fas" fontIcon="fa-eraser"></mat-icon>
                    </button>
                    <button mat-icon-button class="notification-button cursor-pointer-icon" (click)="search()"
                        matTooltip="Pesquisar">
                        <mat-icon fontSet="fas" fontIcon="fa-search"></mat-icon>
                    </button>
                </div>
            </form>
        </mat-card-content>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
        <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoadingDevolucao"></mat-progress-bar>
        <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoadingTransporte"></mat-progress-bar>
        <mat-card-content class="no-padding">
            <div>
                <div id="div-devolucao-table">
                    <h1 mat-dialog-title>
                        Manifestos de Devolução
                    </h1>
                    <table id="devolucaoTable" mat-table [dataSource]="devolucaoCollection" class="table-sm">

                        <ng-container matColumnDef="numeroCompletoManifesto">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Número MDT</th>
                            <td mat-cell *matCellDef="let item" (click)="openModalMEPedidos(item, true)" class="text-center link cursor-pointer-icon">
                                <a>{{ item.numeroCompletoManifesto }}</a></td>
                        </ng-container>

                        <ng-container matColumnDef="volume">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Volume</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.volume }}</td>
                        </ng-container>

                        <ng-container matColumnDef="NRT">
                            <th mat-header-cell *matHeaderCellDef class="text-center">NRT</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.nrt }}</td>
                        </ng-container>

                        <ng-container matColumnDef="valor">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Valor</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.valor | currency:'BRL'}}</td>
                        </ng-container>

                        <ng-container matColumnDef="qtdRessalvas">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Qtd Ressalvas</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.qtdRessalvas }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsDevolucao"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsDevolucao;"></tr>
                    </table>
                    <div *ngIf="!isLoadingDevolucao && devolucaoCollection?.data?.length === 0"
                        class="d-flex justify-content-center align-items-center" style="height: 100px;">
                        Nenhum registro foi encontrado!
                    </div>
                    <app-paginacao [pageIndex]="pagingDevolucao?.index" [pageSize]="pagingDevolucao?.size"
                        [length]="pagingDevolucao?.length" (page)="onPageChangeDevolucao($event)"
                        [pageSizeOptions]="[5, 10, 50, 100]"></app-paginacao>
                </div>
                <!-- <mat-divider id="matVertical" [vertical]="true"></mat-divider> -->
                <div id="div-transporte-table">
                    <h1 mat-dialog-title>
                        Manifestos de Transporte
                    </h1>
                    <table id="transporteTable" mat-table [dataSource]="transporteCollection" class="table-sm">
                        <ng-container matColumnDef="numeroCompletoManifesto">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Número MT</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                              <div *ngIf="(habilitarBaixa || modalItem.baixado);then perm else no_perm"></div>
                              <ng-template #perm>
                                <a (click)="openModalMEPedidos(item, false)"
                                  class="link cursor-pointer-icon">{{ item.numeroCompletoManifesto }}</a>
                              </ng-template>
                              <ng-template #no_perm>
                                <a style="cursor:not-allowed">{{ item.numeroCompletoManifesto }}</a>
                              </ng-template>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="volume">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Volume</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.volume }}</td>
                        </ng-container>

                        <ng-container matColumnDef="NRT">
                            <th mat-header-cell *matHeaderCellDef class="text-center">NRT</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.nrt }}</td>
                        </ng-container>

                        <ng-container matColumnDef="valor">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Valor</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.valor | currency:'BRL'}}</td>
                        </ng-container>

                        <ng-container matColumnDef="qtdRessalvas">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Qtd Ressalvas</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.qtdRessalvas }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsTransporte"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsTransporte;"></tr>
                    </table>
                    <div *ngIf="!isLoadingTransporte && transporteCollection?.data?.length === 0"
                        class="d-flex justify-content-center align-items-center" style="height: 100px;">
                        Nenhum registro foi encontrado!
                    </div>
                    <app-paginacao [pageIndex]="pagingTransporte?.index" [pageSize]="pagingTransporte?.size"
                        [length]="pagingTransporte?.length" (page)="onPageChangeTransporte($event)"
                        [pageSizeOptions]="[5, 10, 50, 100]"></app-paginacao>
                </div>
            </div>
        </mat-card-content>
    </div>
    <mat-divider></mat-divider>

    <div class="modal-actions" mat-dialog-actions align="end">
        <button mat-flat-button (click)="baixarME()"
        [disabled]="!habilitarBaixa || (transporteCollection.data?.length ===0 && devolucaoCollection.data?.length===0) || meBaixado===true || isDownloading === true" class="download-green">
            {{meBaixado===true ? 'Já baixado': 'Baixar'}}
        </button>
        <button mat-flat-button mat-dialog-close color="primary">Sair</button>
    </div>
</div>
